import { BaseClient } from '../client';
import { TUser } from '../user';
import { UsersMock } from '../user/user.mocks';

export const getAllAdminUsers = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return UsersMock;
	// }

	try {
		const response = await BaseClient.get<TUser[]>(`/Admin/GetAdminUsuarios`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
